import { Box, Checkbox, FormControlLabel } from '@mui/material';
import React from 'react';
import { CUSTOMER_PORTAL_TEXT_COLOR } from '../customer-portal-colors';

type ProductCheckboxItem = {
  productName: string;
  color: string;
};

type ProductVisibilityCheckboxesProps = {
  products: ProductCheckboxItem[];
  hiddenProducts: Set<string>;
  onToggle: (productName: string) => void;
};

export const ProductVisibilityCheckboxes: React.FC<ProductVisibilityCheckboxesProps> = ({
  products,
  hiddenProducts,
  onToggle,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: '4px 16px',
        marginBottom: '8px',
      }}
    >
      {products.map((checkboxProduct) => (
        <FormControlLabel
          key={checkboxProduct.productName}
          control={
            <Checkbox
              size="small"
              checked={!hiddenProducts.has(checkboxProduct.productName)}
              onChange={() => onToggle(checkboxProduct.productName)}
              sx={{
                color: checkboxProduct.color,
                '&.Mui-checked': { color: checkboxProduct.color },
                padding: '4px',
              }}
            />
          }
          label={checkboxProduct.productName}
          sx={{
            opacity: hiddenProducts.has(checkboxProduct.productName) ? 0.5 : 1,
            '& .MuiFormControlLabel-label': {
              fontSize: '13px',
              fontFamily: 'Inter, sans-serif',
              color: CUSTOMER_PORTAL_TEXT_COLOR,
            },
          }}
        />
      ))}
    </Box>
  );
};
